import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Typography} from '~library/atoms/Typography';
import {RecommendedFonts} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/RecommendedFonts/RecommendedFonts';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {FontItem} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';
import {AllFonts} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/AllFonts/AllFonts';
import {mapFabricFontToLocal} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/utils';

import './FontsMobile.sass';

export const FontsMobile = () => {
  const {canvas} = useContext(EventCreateContext);
  const [selectedValue, setSelectedValue] = useState({});
  const activeObjects = canvas?.getActiveObjects();

  useEffect(() => {
    setSelectedValue(mapFabricFontToLocal(activeObjects?.[0]));
  }, [activeObjects?.[0]]);

  const onChangeHandler = useCallback(
    (value) => {
      setSelectedValue(value);
      activeObjects.forEach((obj) =>
        obj.set({
          fontFamily: value.family,
          fontStyle: value.style,
          fontWeight: value.weight,
        })
      );
      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [canvas, activeObjects]
  );

  useEffect(() => {
    if (activeObjects?.length) {
      const canvasWrapper = document.querySelector('.event-create-design');
      const y = activeObjects[0].top / 2 - canvasWrapper.clientHeight / 2 + 40;

      canvasWrapper.scrollTo({
        top: y,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [activeObjects]);

  return (
    <div className="fonts__mobile create-flow__texteditor-content">
      <div className="fonts__mobile__bottom">
        <div className="fonts__mobile__bottom__selected_font">
          <FontItem font={selectedValue} selected scroll={false} />
        </div>

        <div className="fonts__mobile__bottom__recommended">
          <RecommendedFonts onChange={onChangeHandler} selectedFont={selectedValue} />
        </div>
        <Typography
          as="h1"
          variant="label2"
          color="pebble"
          classNames="fonts__mobile__bottom__title"
        >
          All fonts
        </Typography>
        <div className="fonts__mobile__bottom__all">
          <AllFonts onClick={onChangeHandler} selectedFont={selectedValue} />
        </div>
      </div>
    </div>
  );
};
